/*
  c-quick-shop: opens the quick shop drawer and fills it per product.

  Loaded once from the section (which is rendered from layout/theme.liquid), so
  the Section Rendering response fetched on every open carries markup only.
  Everything it needs comes from data attributes on the root element.
*/
(function () {
      var root = document.querySelector('[data-quick-shop]');
      if (!root || root.dataset.quickShopInit === 'true') return;
      root.dataset.quickShopInit = 'true';

      var body = root.querySelector('[data-quick-shop-body]');
      var panel = root.querySelector('[data-quick-shop-panel]');
      var lastTrigger = null;
      var currentKey = null;
      /* one entry per product+variant: reopening is then instant, and a prefetch
         started on finger-down is already waiting by the time the click lands */
      var cache = {};
      var pending = {};

      function lockScroll(on) {
        document.documentElement.style.overflow = on ? 'hidden' : '';
      }

      /* The homepage streams several looping testimonial videos. On a phone they
         eat the connection and the panel's own request and images queue behind
         them, which is what made it feel slow. They pause while it is open. */
      var pausedVideos = [];

      function pauseBackgroundVideos() {
        pausedVideos = [];
        document.querySelectorAll('video').forEach(function (video) {
          if (root.contains(video) || video.paused) return;
          video.pause();
          pausedVideos.push(video);
        });
      }

      function resumeBackgroundVideos() {
        pausedVideos.forEach(function (video) {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        });
        pausedVideos = [];
      }

      function open() {
        root.classList.add('is-active');
        lockScroll(true);
        pauseBackgroundVideos();
        panel.focus();
      }

      function close() {
        root.classList.remove('is-active');
        lockScroll(false);
        resumeBackgroundVideos();
        if (lastTrigger) lastTrigger.focus();
        /* Dropping the body cancels whatever images are still downloading: on a
           phone connection they were saturating the link and the next open had to
           queue behind them. The markup is cached, so reopening costs no request. */
        window.setTimeout(function () {
          if (root.classList.contains('is-active')) return;
          body.innerHTML = '';
          currentKey = null;
        }, 320);
      }

      function keyFor(handle, variantId) {
        return handle + ':' + (variantId || '');
      }

      /* The body comes from the Section Rendering API so the panel is built by
         Liquid with the product's prices, selling plans and metafields. */
      function fetchBody(handle, variantId) {
        var key = keyFor(handle, variantId);
        if (cache[key]) return Promise.resolve(cache[key]);
        if (pending[key]) return pending[key];
        var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + root.dataset.sectionId;
        if (variantId) url += '&variant=' + encodeURIComponent(variantId);
        pending[key] = fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, priority: 'high' })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-quick-shop-body]');
            if (!fresh) throw new Error('quick shop: no body in response');
            cache[key] = fresh.innerHTML;
            delete pending[key];
            return cache[key];
          })
          .catch(function (error) {
            delete pending[key];
            throw error;
          });
        return pending[key];
      }

      function prefetch(trigger) {
        if (!trigger) return;
        fetchBody(trigger.getAttribute('data-quick-shop-open'), trigger.getAttribute('data-quick-shop-variant'))
          .catch(function () {});
      }

      function load(handle, variantId) {
        var key = keyFor(handle, variantId);
        if (key === currentKey && body.querySelector('[data-quick-shop-form]')) return Promise.resolve();
        if (!cache[key]) body.innerHTML = '<p class="c-quick-shop__loading">' + (root.dataset.loadingLabel || '') + '</p>';
        return fetchBody(handle, variantId)
          .then(function (html) {
            body.innerHTML = html;
            currentKey = key;
            setupMedia();
          })
          .catch(function (error) {
            console.error(error);
            /* never strand the shopper: fall back to the product page */
            window.location.href = '/products/' + handle + (variantId ? '?variant=' + variantId : '');
          });
      }

      /* media pager: two per page, one dot per pair, as in the node */
      function setupMedia() {
        var slides = body.querySelector('[data-quick-shop-slides]');
        var dots = body.querySelector('[data-quick-shop-dots]');
        if (!slides || !dots) return;
        var count = slides.children.length;
        var pages = count;

        /* the other images wait for the first one, or for the first interaction */
        function hydrateRest() {
          slides.querySelectorAll('img[data-src]').forEach(function (img) {
            img.src = img.getAttribute('data-src');
            if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
          });
        }

        var firstImage = slides.querySelector('img');
        if (firstImage) {
          var whenIdle = function () {
            if (window.requestIdleCallback) window.requestIdleCallback(hydrateRest, { timeout: 1500 });
            else window.setTimeout(hydrateRest, 400);
          };
          if (firstImage.complete) whenIdle();
          else firstImage.addEventListener('load', whenIdle, { once: true });
        }
        slides.addEventListener('pointerdown', hydrateRest, { once: true, passive: true });
        slides.addEventListener('scroll', hydrateRest, { once: true, passive: true });
        dots.innerHTML = '';
        if (pages < 2) return;
        for (var i = 0; i < pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'c-quick-shop__dot' + (i === 0 ? ' is-current' : '');
          dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
          dot.dataset.page = String(i);
          dots.appendChild(dot);
        }
        dots.addEventListener('click', function (event) {
          var dot = event.target.closest('[data-page]');
          if (!dot) return;
          var slide = slides.children[Number(dot.dataset.page)];
          if (slide) slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
        });
        var prev = body.querySelector('[data-quick-shop-prev]');
        var next = body.querySelector('[data-quick-shop-next]');

        function currentIndex() {
          var step = slides.children[0] ? slides.children[0].offsetWidth + 8 : slides.clientWidth;
          return Math.round(slides.scrollLeft / step);
        }

        function goTo(i) {
          var target = slides.children[Math.max(0, Math.min(count - 1, i))];
          if (target) slides.scrollTo({ left: target.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
        }

        if (prev) prev.addEventListener('click', function () { hydrateRest(); goTo(currentIndex() - 1); });
        if (next) next.addEventListener('click', function () { hydrateRest(); goTo(currentIndex() + 1); });

        function update() {
          var atEnd = slides.scrollLeft + slides.clientWidth >= slides.scrollWidth - 2;
          /* the last images fit on screen together, so the scroll stops short of
             the last one's start: at the end, the last dot is the current one */
          var page = atEnd ? count - 1 : currentIndex();
          Array.prototype.forEach.call(dots.children, function (dot, i) {
            dot.classList.toggle('is-current', i === page);
          });
          if (prev) prev.disabled = slides.scrollLeft <= 2;
          if (next) next.disabled = atEnd;
        }

        var raf = null;
        slides.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            update();
          });
        });
        update();
      }

      function addToCart(payload, button) {
        var label = button ? button.innerHTML : '';
        if (button) { button.disabled = true; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            close();
            /* hand over to the cart drawer, where the current buttons end up too */
            if (typeof window.openCart === 'function') window.openCart();
          })
          .catch(function (error) { console.error(error); })
          .finally(function () {
            if (button) { button.disabled = false; button.innerHTML = label; }
          });
      }

      /* Warm the cache while the browser is idle. The store loads a lot of
         third-party script, and on a phone connection our 9KB of markup ends up
         queued behind it; fetched ahead of the tap, opening is instant. Capped,
         and skipped when the connection says otherwise. */
      var PREFETCH_LIMIT = 4;
      var prefetched = 0;

      function prefetchAhead() {
        var conn = navigator.connection;
        if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
        if (!('IntersectionObserver' in window)) return;
        var seen = {};
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || prefetched >= PREFETCH_LIMIT) return;
            var trigger = entry.target;
            var key = keyFor(trigger.getAttribute('data-quick-shop-open'), trigger.getAttribute('data-quick-shop-variant'));
            if (seen[key]) return;
            seen[key] = true;
            prefetched += 1;
            var run = function () { prefetch(trigger); };
            if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 3000 });
            else window.setTimeout(run, 1200);
          });
        }, { rootMargin: '200px' });
        document.querySelectorAll('[data-quick-shop-open]').forEach(function (trigger) {
          observer.observe(trigger);
        });
      }

      if (document.readyState === 'complete') prefetchAhead();
      else window.addEventListener('load', prefetchAhead);

      ['pointerdown', 'touchstart', 'mouseover'].forEach(function (type) {
        document.addEventListener(type, function (event) {
          var trigger = event.target.closest && event.target.closest('[data-quick-shop-open]');
          if (trigger) prefetch(trigger);
        }, { passive: true });
      });

      document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-quick-shop-open]');
        if (trigger) {
          event.preventDefault();
          lastTrigger = trigger;
          open();
          load(trigger.getAttribute('data-quick-shop-open'), trigger.getAttribute('data-quick-shop-variant'));
          return;
        }
        if (event.target.closest('[data-quick-shop-close]')) {
          event.preventDefault();
          close();
          return;
        }
        var subscribe = event.target.closest('[data-quick-shop-subscribe]');
        if (subscribe && root.contains(subscribe)) {
          var payload = {
            id: Number(subscribe.getAttribute('data-variant-id')),
            quantity: 1,
            properties: { _purchase_way: 'Quick Shop' },
          };
          var plan = subscribe.getAttribute('data-selling-plan');
          if (plan) payload.selling_plan = Number(plan);
          addToCart(payload, subscribe);
        }
      });

      root.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-quick-shop-form]');
        if (!form) return;
        event.preventDefault();
        var data = new FormData(form);
        addToCart({
          id: Number(data.get('id')),
          quantity: Number(data.get('quantity')) || 1,
          properties: { _purchase_way: 'Quick Shop' },
        }, form.querySelector('button[type="submit"]'));
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && root.classList.contains('is-active')) close();
      });
    })();
